import { alertaError } from '@/utils/alertas';

export function validarPersona(persona) {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Asegurar que la comparación de fechas sea solo por fecha, no por tiempo

  // Lista de campos requeridos con sus validaciones específicas
  const fields = [
    { value: persona.idTipoIden, field: 'Tipo de Identificación' },
    { value: persona.idLocalidad, field: 'Localidad' },
    { value: persona.idEstadoCivil, field: 'Estado Civil' },
    { value: persona.primerNombre, field: 'Primer Nombre', regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/ },
    { value: persona.segundoNombre, field: 'Segundo Nombre', regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/, optional: true },
    { value: persona.primerApellido, field: 'Primer Apellido', regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/ },
    { value: persona.segundoApellido, field: 'Segundo Apellido', regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/, optional: true },
    { value: persona.fechaNac, field: 'Fecha de Nacimiento', dateValidation: true },
    { value: persona.direccion, field: 'Dirección' },
    { value: persona.telefono, field: 'Teléfono', regex: /^\d{10}$/, message: 'El número de teléfono debe tener 10 dígitos y solo contener números.' },
//    { value: persona.tipoPersona, field: 'Tipo de Persona', regex: /^[NJ]$/, message: 'El tipo de persona debe ser "N" para natural o "J" para jurídica.' },
    { value: persona.sexo, field: 'Sexo', regex: /^[MF]$/, message: 'El sexo debe ser "M" para masculino o "F" para femenino.' },
    { value: persona.email, field: 'Email', regex: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/ },
    { value: persona.idTipoSangre, field: 'Tipo Sangre' },
    { value: persona.estado, field: 'Estado', choices: [0, 1], message: 'El estado debe ser 1 para activo o 0 para inactivo.' }
  ];

  // Validación del documento según el tipo de identificación
  switch (persona.idTipoIden) {
    case 1: // Cédula
      if (!/^\d{10}$/.test(persona.documento)) {
        alertaError('El número de cédula debe tener 10 dígitos.');
        return false;
      }
      break;
    case 2: // RUC
      if (!/^\d{13}$/.test(persona.documento)) {
        alertaError('El número de RUC debe tener 13 dígitos.');
        return false;
      }
      break;
    case 3: // Pasaporte
      if (!/^[a-zA-Z0-9]{1,10}$/.test(persona.documento)) {
        alertaError('El número de pasaporte debe tener hasta 10 caracteres alfanuméricos.');
        return false;
      }
      break;
    default:
      alertaError('Seleccione el tipo de identificación (Tipo Id.).');
      return false;
  }

  for (const { value, field, regex, message, optional, choices, dateValidation } of fields) {
    if (!value && !optional) {
      alertaError(`El campo ${field} es obligatorio.`);
      return false;
    }
    if (value && regex && !regex.test(value)) {
      alertaError(message || `El campo ${field} tiene un formato inválido.`);
      return false;
    }
    if (value && choices && !choices.includes(value)) {
      alertaError(message || `El campo ${field} contiene un valor no permitido.`);
      return false;
    }
    if (value && dateValidation) {
      let datePart = value.substring(0, 10);
      if (!/^(\d{4})-(\d{2})-(\d{2})$/.test(datePart)) {
        alertaError(`Utilice el calendario desplegable para seleccionar la ${field}.`);
        return false;
      }
      const dateValue = new Date(value);
      if (field === 'Fecha de Nacimiento' && dateValue >= today) {
        alertaError(`La fecha de nacimiento no puede ser hoy o una fecha futura.`);
        return false;
      }
    }
  }

  return true; // Todos los campos son válidos
}